import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const SearchIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width={24} height={24} viewBox="0 0 512 512" fill="none" {...props}>
      <path fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32"
            d="M221.09 64a157.09 157.09 0 1 0 157.09 157.09A157.1 157.1 0 0 0 221.09 64Z"/>
      <path fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="32"
            d="M338.29 338.29L448 448"/>
    </SvgIcon>
  );
};

